
  var owl = $('.owl-carousel-11');
  owl.owlCarousel({
    margin: 5,
    loop: false,
    responsive: {
        0: {
        items: 1
        },
        600: {
        items: 1
        },
        1000: {
        items: 1
        }
    }
  })
